var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-width":"100%","width":"100%","height":"auto"}},[_c('video',{ref:"videoPlayer",staticClass:"video-js",staticStyle:{"max-width":"100%","height":"auto"}})])}
var staticRenderFns = []

export { render, staticRenderFns }